module.exports = __webpack_public_path__ + "img/pre-consult-rule-img.20b9a0da.png";